<template>
  <div class="content">
    <!-- 상단 필터 영역: 날짜 + 3시간 버킷 + 단축 -->
    <card>
      <div class="row align-items-center g-2">
        <div class="col-md-3">
          <el-date-picker
            v-model="filters.date"
            type="date"
            placeholder="날짜 선택"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="onDateChange"
            class="w-100"
          />
        </div>
        <div class="col-md-3">
          <el-select v-model="filters.time" placeholder="시간(3h)" class="w-100" @change="onFilterChange">
            <el-option v-for="b in buckets" :key="b.time" :label="b.label" :value="b.time" />
          </el-select>
        </div>
        <div class="col-md-4 d-flex align-items-center gap-2">
          <base-button type="default" @click="onPrev">이전</base-button>
          <base-button type="default" @click="onNext">다음</base-button>
          <base-button type="default" @click="onLatest">최신</base-button>
        </div>
      </div>
    </card>

    <!-- 본문: 좌(랭크) / 우(게시물) -->

    <div class="row g-3">
      <!-- 왼쪽: 랭크 리스트 -->
      <div class="col-sm-3">
        <div class="card">
          <div class="card-header fw-semibold">랭크</div>
          <ul class="list-group list-group-flush">
            <li
              v-for="rank in ranks"
              :key="rank.id"
              class="list-group-item list-group-item-action d-flex align-items-center gap-2"
              :class="{ active: rank.id === selectedRankId }"
              role="button"
              @click="onSelectRank(rank)"
            >
              <div class="flex-grow-1">
                <div class="d-flex justify-content-between">
                  <span class="fw-semibold">{{ rank.artistName }}</span>
                </div>
                <div class="text-muted small">#{{ rank.keyword }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 오른쪽: 선택한 랭크의 게시물 카드 -->
      <div class="col-sm-9">
        <div v-if="posts.length" class="row g-3">
          <div class="col-4" v-for="post in posts" :key="post.id || post.contentId">
            <div class="card h-100">
              <img v-if="post.imageUrl" :src="post.imageUrl" :alt="post.title" class="card-img-top" />
              <div class="card-body d-flex flex-column">
                <h5 class="card-title fs-6 mb-1">{{ post.title }}</h5>
                <p class="card-text text-muted small mb-2">{{ post.source }} · {{ post.date }}</p>
                <p class="card-text flex-grow-1" v-if="post.description">{{ post.description }}</p>
                <div class="d-flex gap-2 mt-2">
                  <base-button type="default" @click="openDetail(post)">상세</base-button>
                  <base-button type="primary" @click="openComments(post)">댓글</base-button>
                  <base-button type="danger" @click="deletePost(post)">삭제</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="card">
          <div class="card-body text-center text-muted py-5">필터를 선택하고 왼쪽 랭크를 클릭하면 게시물이 표시됩니다.</div>
        </div>
      </div>
    </div>

    <!-- 댓글 팝업 -->
    <el-dialog :visible.sync="commentsVisible" width="720px" :append-to-body="true" title="댓글 목록">
      <div v-if="commentsLoading" class="text-center py-4">로딩 중...</div>
      <div v-else>
        <div v-if="!comments.length" class="text-center text-muted py-4">댓글이 없습니다.</div>
        <ul v-else class="list-group">
          <li v-for="c in comments" :key="c.id" class="list-group-item d-flex justify-content-between align-items-start gap-3">
            <div class="me-3">
              <a href="#" @click.prevent="openUser(c.userId)">{{ c.nickname || c.userId }}</a>
              <div class="small text-muted mt-1">
                <span v-if="c.state !== 1">삭제됨 · </span>
                {{ new Date(c.regTime).toLocaleString() }}
              </div>
            </div>
            <div class="flex-grow-1 ms-2">
              {{ c.comment }}
            </div>
            <div class="ms-3">
              <base-button size="sm" :type="c.state === 1 ? 'danger' : 'default'" @click="toggleComment(c)">
                {{ c.state === 1 ? "삭제" : "복구" }}
              </base-button>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";

export default {
  name: "ViewerRank",
  components: { Card },
  data() {
    return {
      // 상단 필터
      filters: {
        unitId: null,
        date: null, // 'YYYY-MM-DD'
        time: null, // yyyymmddHH (number)
      },
      buckets: [], // [{ time: 2025091700, label: '00:00' }, ...]

      // 좌측 랭크 (아티스트명 + 키워드)
      ranks: [
        { id: 1, artistName: "아이유", keyword: "컴백" },
        { id: 2, artistName: "방탄소년단", keyword: "월드투어" },
        { id: 3, artistName: "뉴진스", keyword: "차트 1위" },
      ],
      selectedRankId: null,

      // 우측 카드들
      posts: [], // { id, title, link, imageUrl, source, date, description }
      commentsVisible: false,
      commentsLoading: false,
      comments: [], // [{ id, contentId, unitId, userId, comment, state(1=active,0=deleted), regTime, modTime }]
      commentsForContentId: null,
    };
  },
  created() {
    const { time, unitId, contentId } = this.$route.query;
    if (time) {
      this.applyTime(Number(time));
    } else {
      this.onLatest();
    }
    if (unitId) this.filters.unitId = Number(unitId); // 첫 진입시에만 적용
    if (contentId) {
      this.$nextTick(() => this.openComments({ id: Number(contentId) }));
      const url = new URL(window.location.href);
      url.searchParams.delete("contentId");
      window.history.replaceState({}, "", url);
    }
  },
  watch: {
    "$route.query"(q) {
      if (q.time && Number(q.time) !== this.filters.time) {
        this.applyTime(Number(q.time));
      }
    },
  },
  methods: {
    toDateFromTimeNum(tNum) {
      const s = String(tNum);
      const y = Number(s.slice(0, 4));
      const m = Number(s.slice(4, 6)) - 1;
      const d = Number(s.slice(6, 8));
      const h = Number(s.slice(8, 10));
      return new Date(y, m, d, h, 0, 0, 0);
    },
    timeNumFromDate(dt) {
      const y = String(dt.getFullYear());
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const d = String(dt.getDate()).padStart(2, "0");
      const h = String(dt.getHours()).padStart(2, "0");
      return Number(`${y}${m}${d}${h}`);
    },
    applyTime(t) {
      // t: yyyymmddHH
      const y = String(t).slice(0, 4);
      const m = String(t).slice(4, 6);
      const d = String(t).slice(6, 8);
      const dateStr = `${y}-${m}-${d}`;
      this.filters.time = t;
      this.filters.date = dateStr; // el-date-picker v-model 업데이트 → 달력 날짜 변경
      // URL 동기화
      const url = new URL(window.location.href);
      url.searchParams.set("time", t);
      url.searchParams.delete("unitId"); // unitId는 항상 제거
      window.history.replaceState({}, "", url);
      // 날짜 버킷 재생성 및 동일 시각 선택 유지
      this.buckets = this.makeBucketsForDate(dateStr);
      this.onFilterChange();
    },
    async onDateChange(val) {
      // 선택된 날짜의 3시간 버킷 8개 생성 (00/03/06/09/12/15/18/21)
      this.buckets = this.makeBucketsForDate(val);
      if (this.buckets.length) {
        this.filters.time = this.buckets[this.buckets.length - 1].time;
        await this.onFilterChange();
      }
    },
    async onFilterChange() {
      this.selectedRankId = null;
      this.posts = [];
      const { data } = await this.$axios.get("/viewer/ranks", { params: { time: this.filters.time } });
      this.ranks = data?.data ?? [];
      if (this.filters.unitId) {
        const match = this.ranks.find((r) => r.unitId === this.filters.unitId);
        if (match) {
          this.onSelectRank(match);
          this.filters.unitId = null;
        }
      }
    },
    async jump(which) {
      const now = new Date();
      const baseH = now.getHours() - (now.getHours() % 3);
      now.setHours(baseH, 0, 0, 0);
      const latest = this.timeNumFromDate(now);
      if (which === "latest") return this.applyTime(latest);
      if (typeof which === "number") {
        const dt = new Date(now.getTime() + which * 3 * 60 * 60 * 1000); // which는 0, -1, -2 등
        const t = this.timeNumFromDate(dt);
        return this.applyTime(t);
      }
    },
    onSelectRank(rank) {
      if (!rank || rank.id === this.selectedRankId) return;
      this.selectedRankId = rank.id;
      this.filters.unitId = rank.unitId;
      // URL 동기화 (time만)
      const url = new URL(window.location.href);
      url.searchParams.set("time", this.filters.time);
      url.searchParams.delete("unitId");
      window.history.replaceState({}, "", url);
      this.fetchPostsByRank(rank);
    },
    async fetchPostsByRank(rank) {
      const { data } = await this.$axios.get(`/viewer/ranks/contents`, { params: { time: rank.time, unitId: rank.unitId } });
      this.posts = data?.data ?? [];
    },
    onLatest() {
      // 현재 시간을 3시간 경계로 내림하여 최신 버킷으로 이동
      const now = new Date();
      const baseH = now.getHours() - (now.getHours() % 6);
      now.setHours(baseH, 0, 0, 0);
      const t = this.timeNumFromDate(now);
      this.applyTime(t);
    },
    onPrev() {
      // 현재 선택된 time에서 3시간 이전으로 이동 (날짜 경계 자동 반영)
      if (!this.filters.time) return this.onLatest();
      const cur = this.toDateFromTimeNum(this.filters.time);
      const prev = new Date(cur.getTime() - 6 * 60 * 60 * 1000);
      const t = this.timeNumFromDate(prev);
      this.applyTime(t);
    },
    onNext() {
      // 현재 선택된 time에서 3시간 이후로 이동 (날짜 경계 자동 반영)
      if (!this.filters.time) return this.onLatest();
      const cur = this.toDateFromTimeNum(this.filters.time);
      const next = new Date(cur.getTime() + 6 * 60 * 60 * 1000);
      // 최신을 넘어가지 않도록 현재 시각(스냅) 상한 적용 (선택 사항)
      const now = new Date();
      const baseH = now.getHours() - (now.getHours() % 6);
      now.setHours(baseH, 0, 0, 0);
      if (next.getTime() > now.getTime()) return; // 이미 최신이면 무시
      const t = this.timeNumFromDate(next);
      this.applyTime(t);
    },
    makeBucketsForDate(dateStr) {
      // dateStr = 'YYYY-MM-DD' → [{ time: yyyymmddHH, label: 'HH:00' }]
      if (!dateStr) return [];
      const y = dateStr.slice(0, 4);
      const m = dateStr.slice(5, 7);
      const d = dateStr.slice(8, 10);
      const hours = ["00", "06", "12", "18"];
      return hours.map((hh) => ({ time: Number(`${y}${m}${d}${hh}`), label: `${hh}:00` }));
    },
    makeRecentBuckets(n = 10) {
      // 오늘 기준으로 3시간 단위(00/03/06/09/12/15/18/21)에 스냅하여 역순 n개 생성
      const now = new Date();
      const curH = now.getHours();
      const baseH = curH - (curH % 3); // 3시간 단위 바운더리로 내림
      const base = new Date(now);
      base.setHours(baseH, 0, 0, 0);

      const list = [];
      for (let i = 0; i < n; i++) {
        const t = new Date(base.getTime() - i * 3 * 60 * 60 * 1000);
        const y = String(t.getFullYear());
        const m = String(t.getMonth() + 1).padStart(2, "0");
        const d = String(t.getDate()).padStart(2, "0");
        const h = String(t.getHours()).padStart(2, "0");
        list.push({ time: Number(`${y}${m}${d}${h}`), label: `${h}:00` });
      }
      return list;
    },
    openDetail(post) {
      const contentId = post.contentId != null ? post.contentId : post.id;
      const url = `/radars/radarContentDetail?unitId=${post.unitId}&contentId=${contentId}`;
      window.open(url, "_blank");
    },
    async deletePost(post) {
      try {
        const id = post.id;
        if (!id) return;
        await this.$axios.delete(`/viewer/${id}`);
        this.posts = this.posts.filter((p) => p.id !== id);
      } catch (e) {
        console.error(e);
      }
    },
    openComments(post) {
      const contentId = post.id;
      if (!contentId) return;
      this.commentsForContentId = contentId;
      this.commentsVisible = true;
      this.loadComments(contentId);
    },
    async loadComments(contentId) {
      try {
        this.commentsLoading = true;
        this.comments = [];
        const { data } = await this.$axios.get(`/viewer/contents/${contentId}/comments?type=1`);
        this.comments = data?.data ?? [];
      } catch (e) {
        console.error(e);
      } finally {
        this.commentsLoading = false;
      }
    },
    openUser(userId) {
      if (!userId) return;
      const url = `/user/userDetail?userId=${userId}`;
      window.open(url, "_blank");
    },
    async toggleComment(c) {
      try {
        if (!c?.id) return;
        await this.$axios.put(`/viewer/contents/${this.commentsForContentId}/comments/${c.id}/toggle?type=1`);
        c.state = c.state === 1 ? 0 : 1;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
